import styled, { device, themeGet } from "@styled";
import SwiperSlider from "../../../components/ui/swiper";
import Image from "../../../components/ui/image";
import Container from "../../../components/ui/wrapper/container";

export const HeroWrapper = styled.div`
    position: relative;
    isolation: isolate;
    z-index: 1;
    padding-block: 60px;
    background-color: #000;
    ${device.medium} {
        padding-block: 80px;
    }
    ${device.large} {
        padding-block: 120px;
        background-color: #f8f8f8;
    }
`;

export const HeroSlider = styled(SwiperSlider)`
    max-width: 100vw;
    max-height: 100vh;
    min-height: 100%;

    position: absolute;
    inset: 0;
    z-index: -1;
`;

export const HeroImage = styled(Image)`
    min-height: 100%;
    min-width: 100%;
    padding-bottom: 0;

    ${device.small} {
        min-height: 790px;
    }
`;

export const HeroContainer = styled(Container)`
    width: 100%;
    max-width: 100%;
    ${device.medium} {
        position: relative;
        left: 2px;
    }
    ${device.large} {
        position: relative;
        left: 2px;
        top: -91px;
    }
`;

export const HeroTextWrap = styled.div`
    text-align: center;
    margin-block-end: 60px;
    ${device.medium} {
        text-align: left;
        margin-block-end: 0;
    }
`;

export const HeroButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${device.medium} {
        justify-content: flex-start;
    }
`;

export const AppointmentWrap = styled.div`
    max-width: 400px;
    background: #fff;
    box-shadow: 0 2px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${themeGet("radii.md")};
    text-align: center;
    margin-inline-start: auto;
    margin-inline-end: auto;
    padding-block-start: 42px;
    padding-block-end: 51px;
    padding-inline-start: 30px;
    padding-inline-end: 30px;
`;

export const AppointmentTitleWrap = styled.div`
    margin-block-end: 40px;
    text-align: center;
`;

export const AppointmentFormWrap = styled.div`
    text-align: start;
`;

export const StyledSubtitle = styled.h6`
    color: #fff;
`;

export const StyledTitle = styled.h6`
    font-weight: 500;
    font-size: 250%;
    color: #fff;
    margin-block-end: 30px;
    font-style: oblique;
    margin-right: 16px;
`;
